<template>
	<!--  <keep-alive>
    <div id="app">
      <router-view />
    </div>
  </keep-alive> -->

	<keep-alive>
		<div id="app">
			<router-view :key="key" />
		</div>
	</keep-alive>


</template>

<script>
	import {
		banBackSpace
	} from "@/until/preventBackspace";
	export default {



		name: "App",
		data() {
			return {
				tagsList: [],
			}
		},
		components: {},
		computed: {
			cachedViews() {
				// return this.$store.state.tagsView.cachedViews''
			},
			key() {
				// return this.$route.path
			}
		},
		mounted() {
			document.onkeypress = banBackSpace;
			document.onkeydown = banBackSpace;
		},
	};
</script>

<style>
	html,
	body,
	#app,
	.el-container {
		/*设置内部填充为0，几个布局元素之间没有间距*/
		padding: 0px;
		/*外部间距也是如此设置*/
		margin: 0px;
		/*统一设置高度为100%*/
		height: 100%;
		overflow-x: auto;
	}
	
	.ql-editor {
	  white-space: normal !important;
	}
	 
	.ql-container {
	  white-space: pre-wrap !important;
	}

	.list {
		background-color: #e8e8e8;
	}

	.el-card {
		height: auto;
		width: 100%;
		overflow-y: auto !important;
		overflow-x: auto !important;
	}

	.el-main {
		width: 100%;
	}

	.buttonStyle {
		margin-bottom: 15px;
	}

	.el-table th.gutter {
		display: table-cell !important;
	}

	/* .cell {
    max-height: 23px;
  } */

	input[type="number"] {
		-moz-appearance: textfield;
	}

	input[type="number"]::-webkit-inner-spin-button,
	input[type="number"]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	.viewer-container {
		z-index: 9999999999 !important;
	}

	@media print {

		html,
		body {
			height: inherit;
		}

	}

	#printcontent {
		width: 100%;
		height: 100%;
		overflow: hidden;


	}

	#printcontent img {
		/*    width: 100%;
    height: 100%; */
		max-width: 600px;
		width: 600px;
		width: expression(document.body.clientWidth>600?'600px':'auto');
		overflow: hidden;
	}

	/* //使用媒体查询    设置预览时的样式 */
	@media print {
		@page {
			margin: 0;
			size: portrait;
		}

		#printcontent {
			width: 100%;
		}

		.print_img {
			display: block;
			width: 100%;
			height: 100%;
			margin: auto auto;
			object-fit: none
		}
	}

	.lookheight .el-dialog {
		width: 660px !important;
		max-height: 800px;
		min-height: 600px;
		overflow-y: scroll;
	}

	.viewer-toolbar>ul {
		margin: 0 auto 50px !important;
		transform: scale(2, 2) !important;
	}

	.viewer-title {
		margin: 0 5% 30px !important;
	}

	.biaoq {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 35px 0;
		box-sizing: border-box;
	}

	.biaoq .biaoq_shu {
		width: 6px;
		height: 27px;
		background: #1A1A1A;
	}

	.biaoq .biaoq_title {
		font-size: 24px;
		color: #1A1A1A;
		line-height: 24px;
		margin-left: 20px;
	}

	.login_ipt .el-input__inner {
		width: 409px;
		height: 61px;
		border: none !important;
		border-radius: 30px;
		padding-left: 60px!important;
		font-size: 20px;
	}

	.login_yzm .el-input__inner {
		width: 274px;
		height: 61px;
		border: none !important;
		border-radius: 30px;
		padding-left: 60px !important;
		font-size: 20px;
	}

	.login_ipt .el-input__prefix {
		font-size: 30px !important;
	}

	.login_ipt .el-input__icon {
		width: 50px !important;
	}

	.zhus .el-form-item__content {
		width: 100%;
		margin-top: 20px;
	}
	.zhusss  .el-input__inner {
		border: 1px solid #EEEEEE !important;
		
	}
	.zhusss  .el-form-item__content{
		margin-left: 0 !important;
	}
	.el-form-item__label{
		text-align: left !important;
		font-size: 16px;
	}
	.el-radio__label{
		font-size: 18px !important;
		/* line-height: 20px !important; */
	}
	.el-radio__inner{
		width: 20px !important;
		height: 20px !important;
		margin-top: -4px;
	}
	.el-radio__inner::after {
		width: 8px !important;
		height: 8px !important;
	}
	
	.left .el-checkbox__label{
		font-size: 18px !important;
		/* line-height: 20px !important; */
	}
	.left .el-checkbox__inner{
		width: 20px !important;
		height: 20px !important;
		margin-top: -4px;
	}
	.left .el-checkbox__inner::after {
		width: 7px !important;
		height: 11px !important;
	}
	.cont_title{
		font-size: 24px;
		font-weight: 400;
		color: #333333;
		line-height: 28px;
		padding-left: 14px;
		border-left: 6px solid #ED7F26;
	}
	.backgo{
		display: flex;
		align-items: center;
		cursor: pointer;
		margin-bottom: 20px;
		margin-top: -15px;
		margin-left: -15px;
	}
	.backgo img{
		width: 26px;
		height: 26px;
		margin-right: 10px;
	}
	.backgo div{
		font-size: 22px;
		font-weight: 400;
		color: #333333;
	}
	.className{
		width: 100%;
		display: flex;
		align-items: center;
		margin-top: 30px;
	}
	.className_item{
		width: 50%;
		display: flex;
		align-items: center;
	}
	.className_item_left{
		font-size: 18px;
		color: #333333;
		line-height: 36px;
		margin-right: 10px;
	}
	.className_item_right{
		width: 400px;
		height: 36px;
		background: #FFEBDB;
		font-size: 16px;
		font-weight: 400;
		color: #333333;
		line-height: 36px;
		box-sizing: border-box;
		padding-left: 15px;
	}
	/* .contentmine */
</style>



// WEBPACK FOOTER //
// src/App.vue